module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLightItalic.3635f9d0.woff2";